import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import "../css/nav.css";
import logo from "../images/LogoLong.png";
import { Link } from "gatsby";

// markup
const Navigation = () => {
    useEffect(() => {
        return () => { }
    }, []);
    return (
        <nav id="nav-bar">
            <Helmet>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
            </Helmet>
            <div className="nav-item">
                <Link to="/" className="logo"><img id="logo" src={logo} alt="header logo"></img></Link>
                {/* <Link to="/" className="logo"><img id="logo" src={logo}></Link> */}
                <Link to="/">Home</Link>
                <Link to="/talent">Talent</Link>
                <Link to="/guideline">Guidline</Link>
                {/* <Link to="/audition">Audition</Link> */}
                <Link to="/contact">Contact</Link>
                {/* <a href="/">Contact</a> */}
            </div>
            <div className="socials">
                <a href="https://www.youtube.com/channel/UCDZ9IS3qPuacdG_GhGiB7Gg" target="_blank" className="" rel="noreferrer">Youtube</a>
                <a href="https://twitter.com/_ProjectNebula" target="_blank" className="" rel="noreferrer">Twitter</a>
            </div>
        </nav>
    )
}

export default Navigation
